import 'whatwg-fetch';
import qs from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import Box from "signoxe/components/layout/Box";
import Button from "signoxe/components/widgets/Button";
import { getAsset } from 'signoxe/selectors';
import { Page } from 'signoxe/components';
import { API_ROOT } from 'signoxe/constants/config';
import {
  setAQICities, setAQIStations, setPageTitle,
  addAQIAsset, updateAQIAsset,
} from "signoxe/actions";

class AQIAssetPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      city: "",
      station: "",
    }
  }

  componentDidMount() {
    if (this.props.cities.length === 0) {
        const requestOptions = {
          method: 'GET',
          headers: {},
        };
        fetch(`${API_ROOT}airquality/cities/`, requestOptions).then(response => {
            if (response.ok) {
              return response.json();
            }
        }).then(obj => {
          if (obj) {
            this.props.setAQICities(obj);
          }
        });
    }

    this.props.setPageTitle('Adding AQI Asset');
  }

  render() {
    return <div className="asset-editing-page">
      <input type="text" placeholder="Asset name"
             value={this.state.name}
             onChange={event => this.setState({name: event.target.value})}/>
      {this.props.cities.length === 0 ?
        <p>Loading cities...</p> :
        <select
            name="city" onChange={event => this.changeSelectedCity(event.target.value)}
            value={this.state.city}
        >
            <option value="">Please choose a city</option>
            {this.props.cities.sort().map(city => <option key={city} value={city}>{city}</option>)}
        </select>
      }
      {this.state.city ?
        (this.props.stations[this.state.city] ?
          <select
            name="station" onChange={event => this.changeSelectedStation(event.target.value)}
            value={this.state.station}
          >
            <option value="">Please choose a station</option>
            {this.props.stations[this.state.city].sort().map(station => <option key={`${this.state.city}-${station}`} value={station}>{station}</option>)}
          </select> :
          <p>Loading stations...</p>
        ) :
        null
      }

      <Box direction="row" justifyContent="flex-end" className="actions button-group">
        <Button primary onClick={this.saveEnabled() ? event => this.save() : null}>Save</Button>
        {/* <Button secondary onClick={event => this.cancel()}>Cancel</Button> */}
      </Box>
    </div>
  }

  changeSelectedCity(city) {
    this.setState({city, station: ''});
    if (!this.props.stations[city]) {
        const requestOptions = {
          method: 'GET',
          headers: {},
        };
        fetch(`${API_ROOT}airquality/stations/?${qs.stringify({city})}`, requestOptions).then(response => {
            if (response.ok) {
              return response.json();
            }
        }).then(obj => {
          if (obj) {
            this.props.setAQIStations(city, obj);
          }
        });
    }
  }

  changeSelectedStation(station) {
    this.setState({station});
  }

  saveEnabled() {
    return this.state && this.state.name && this.state.city && this.state.station;
  }

  cancel() {
    this.props.history.push('/assets');
  }

  save()  {
    this.props.addAQIAsset({...this.state, asset_url: JSON.stringify(this.state)});
  }

  isNewAsset() {
    return this.props.match.params.id === undefined
  };
}

const mapStateToProps = (state, ownProps) => {
  const aqiStations = state.uiState.aqiStations;
  return {
    cities: aqiStations.cities,
    stations: aqiStations.stations
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setPageTitle: title => dispatch(setPageTitle(title)),
    setAQICities: cities => dispatch(setAQICities(cities)),
    setAQIStations: (city, stations) => dispatch(setAQIStations(city, stations)),

    addAQIAsset: data => dispatch(addAQIAsset(data)),
    updateAQIAsset: (id, data) => dispatch(updateAQIAsset(id, data)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(AQIAssetPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetModal/components/Aqi.js